import { action, observable } from 'mobx';

import BoostService from 'services/BoostService';
import messagingService from 'services/MessagingService/MessagingService';
import {
  BOOST_CAM_ERROR,
  BOOST_CAM_RESPONSE,
} from 'services/MessagingService/EventNames';
import APIStates from 'enum/APIStates';


class BoostStore {
  constructor(messagingService) {
    this.messagingService = messagingService();
    this.messagingService.on(BOOST_CAM_RESPONSE, this._handleBoostCamResponse);
    this.messagingService.on(BOOST_CAM_ERROR, this._handleBoostCamError);
  }

  destructor() {
    this.messagingService.off(BOOST_CAM_RESPONSE, this._handleBoostCamResponse);
    this.messagingService.off(BOOST_CAM_ERROR, this._handleBoostCamError);
  }

  @observable boostStatus = APIStates.INITIAL;
  @observable boostError = null;
  @observable freeBoost = false;

  @action boostCam = (data) => {
    this.boostStatus = APIStates.PENDING;
    BoostService.boostCam(data);
  };

  @action checkFreeBoosts = (data) => {
    const { accessHash, username } = data;
    BoostService.getAvailableFreeBoosts({
      accessHash,
      username,
      freeBoost: true,
    }).then((response) => {
      this.freeBoost = !response?.data.length;
    });
  };

  @action resetBoostStatus = (status) => {
    this.boostStatus = status;
    this.boostError = null;
  };

  @action _handleBoostCamResponse = (data) => {
    this.boostStatus = APIStates.LOADED;
    if (data && data.freeBoost) {
      const { accessHash, username } = data;
      this.checkFreeBoosts({ accessHash, username });
    }
  };

  @action _handleBoostCamError = (error) => {
    const errorMessage = error.response.data.error;
    if (errorMessage === 'FREE_BOOST_UNAVAILABLE') {
      this.freeBoost = false;
      this.boostError = null;
    } else {
      this.boostError = errorMessage;
    }
    this.boostStatus = APIStates.ERROR;
  };
}

export const BoostStoreClass = BoostStore;

export default new BoostStore(messagingService);
